import { render, staticRenderFns } from "./AuthView.vue?vue&type=template&id=6bd0ed44&scoped=true&"
import script from "./AuthView.vue?vue&type=script&lang=js&"
export * from "./AuthView.vue?vue&type=script&lang=js&"
import style0 from "./AuthView.vue?vue&type=style&index=0&id=6bd0ed44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd0ed44",
  null
  
)

export default component.exports